export const EXTERNALIMAGEFRAMES = 7
export const EXTERNALIMAGEPREFIX = 'img'
export const EXTERNALVIDEOPREFIX = 'video'
export const EXTERNALIMAGETHUMBNAIL = 'Thumbnail'
